export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_14.886ac745.jpg";